import React, { Component } from "react";
import BreadCrumbs from "../../Elements/BreadCrumbs/BreadCrumbs";

export default class Top extends Component {
    render() {
        console.log(this.props,'top component');
        if (this.props.config.breadcrumbs && this.props.config.breadcrumbs.length > 1 && !this.props.config.back_arrow) {
            return (
                <section className="content_top">
                    <BreadCrumbs
                        title={this.props.config.back_translation}
                        only_breadcrumbs={true}
                        back_arrow={this.props.config.back_arrow}
                        breadcrumbs={this.props.breadcrumbs}
                        newBread={this.props.config.breadcrumbs}
                    />
                </section>
            );
        } else if (this.props.config.back_arrow && this.props.config.breadcrumbs) {
            return (
                <section className="content_top">
                    <BreadCrumbs
                        title={this.props.config.back_translation}
                        both={true}
                        back_arrow={this.props.config.back_arrow}
                        breadcrumbs={this.props.breadcrumbs}
                        newBread={this.props.config.breadcrumbs}
                    />
                </section>
            );
        }
        else if (this.props.config.back_arrow && !this.props.config.breadcrumbs) {
            return (
                <section className="content_top">
                    <BreadCrumbs
                        title={this.props.config.back_translation}
                        back_arrow={true}
                        // back_arrow={this.props.config.back_arrow}
                        breadcrumbs={this.props.breadcrumbs}
                        newBread={this.props.config.breadcrumbs}
                    />
                </section>
            );
        }

        else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Components/Content/Top/index.js